export default {"src":"/_next/static/media/new.1da842ec.svg","height":20,"width":56,"blurWidth":0,"blurHeight":0};